module.exports = __webpack_public_path__ + "static/media/award.7a13fa39.png";